import { render, staticRenderFns } from "./MicrophoneIcon.vue?vue&type=template&id=6566091b"
import script from "./MicrophoneIcon.vue?vue&type=script&lang=js"
export * from "./MicrophoneIcon.vue?vue&type=script&lang=js"
import style0 from "./MicrophoneIcon.vue?vue&type=style&index=0&id=6566091b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports